import { useContext } from 'react'

import { AuthContext } from '@/lib/auth-context-instance'

/** Organization modules the front reads (codes owned by the backend, `ModuleCodes.cs`). */
export const MODULES = {
  /** SOLY-SUPPLIER-002 — Outlook mailboxes for supplier orders, supplier import. */
  PURCHASE_MAILBOX: 'purchase.mailbox',
  /** Winner export → customer, project and quote in one go. */
  QUOTE_IMPORT: 'quote_import',
} as const

export type ModuleCode = (typeof MODULES)[keyof typeof MODULES]

/**
 * Which modules Soly switched on for the organization. Hides entry points only: every endpoint of a
 * module carries `[RequireModule]` on the server, the authority.
 *
 * Outside the provider (components mounted alone in tests) every module reads as on — the same
 * convention as `usePermissions`, so a test does not silently render a module's screen empty.
 */
export function useModules() {
  const auth = useContext(AuthContext)
  const outsideProvider = auth === undefined
  const modules = auth?.user?.modules ?? []

  return {
    hasModule: (code: ModuleCode) => outsideProvider || modules.includes(code),
  }
}
